import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { SendUsMessageLink } from "./SendUsMessageLink";
import { AppLogo } from "./AppLogo";
import {
  useCurrentBrand,
  useCurrentWorkspace,
} from "../../hooks/useCurrentWorkspace";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContemt: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  logoInvert: {
    ...(theme.palette.mode === "dark" && {
      filter: "invert(1)",
    }),
  },
  notFoundTitle: {
    fontSize: 32,
    fontWeight: "normal",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(6),
    textAlign: "center",
  },
  homeButton: {
    fontSize: 13,
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.125, 4),
  },
  split: {
    border: 0,
    borderTop: `1px solid ${theme.palette.border.primary}`,
    margin: theme.spacing(5, 0, 3),
  },
  notFoundText: {
    fontSize: 16,
    color: theme.palette.text.primary,
  },
}));

export interface Error40XProps extends BoxProps {
  message: React.ReactNode;
}

export function Error40X(props: Error40XProps) {
  const { className, message, ...other } = props;
  const s = useStyles();
  const workspace = useCurrentWorkspace();
  const { isBrandedApp } = useCurrentBrand();
  const isStridistLogo = !isBrandedApp && !workspace?.logoUrl;

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <AppLogo className={clsx(s.logo, isStridistLogo && s.logoInvert)} />
      <Typography
        className={s.notFoundTitle}
        variant="h2"
        children={
          <>
            Woops!
            <br />
            {message}
          </>
        }
      />
      <Button
        className={s.homeButton}
        variant="contained"
        href="/"
        children="Back to Home"
      />
      <hr className={s.split} />
      <Typography className={s.notFoundText}>
        Need help? <SendUsMessageLink />
      </Typography>
    </Box>
  );
}
